import { contractCancellation } from './contractCancellation';
import { facialRecognition } from './facialRecognition';
import { profile } from './profile';

const esCR = {
  ...contractCancellation,
  ...facialRecognition,
  ...profile,
};

export default esCR;
